<template>
  <div class="pb-3" >
    <va-card :title="$t(`settings.cards.${titleCard}`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Item" v-slot="{ errors }">
                <va-input
                  v-model="item.key"
                  :label="$t('settings.forms.keyLabel')"
                  :placeholder="$t('settings.forms.keyPlaceholder')"
                  :success="errors.length == 0 && item.key.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Item" v-slot="{ errors }">
                <va-input
                  v-model="item.value"
                  :label="$t('settings.forms.valueLabel')"
                  :placeholder="$t('settings.forms.valuePlaceholder')"
                  :success="errors.length == 0 && item.value.length >= 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="buttonSubmitDisabled"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
                <va-button
                  type="button"
                  class="my-0"
                  color="danger"
                  @click="cancel">
                  {{ $t("forms.cancel") }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'SettingsAddUpdate',
  props: {
    page: {
      type: Number,
      required: true,
    },
    titleCard: {
      type: String,
      required: true,
    },
    updateData: {
      required: true,
    },
  },
  data () {
    return {
      item: {
        key: '',
        value: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  created () {
    this.item.key = ''
    this.item.value = ''
    if (this.updateData !== null) {
      this.item_get(this.updateData)
    }
  },
  watch: {
    updateData (value) {
      if (this.updateData !== null) {
        this.item_get(this.updateData)
      } else {
        this.item.key = ''
        this.item.value = ''
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('showAdd', false)
    },
    item_get (data) {
      Object.keys(data).forEach((value, key) => {
        if (value !== '__typename') {
          this.item[value] = data[value]
        }
      })
    },
    onSubmit () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.submitting')
      const { key, value } = this.item
      this.$apollo
        .mutate({
          mutation: (
            this.updateData !== null ? gql`
                mutation MyMutation($id: Int!, $key: String!, $value: String!) {
                  update_settings_by_pk(pk_columns: {id: $id}, _set: {key: $key, value: $value}) {
                    id
                  }
                }
                ` : gql`
                  mutation MyMutation($key: String!, $value: String!) {
                  insert_settings(objects: {key: $key, value: $value}) {
                    affected_rows
                  }
                }
                `),
          variables: this.updateData !== null ? {
            key,
            value,
            id: this.item.id,
          } : { key, value },
        })
        .then(data => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.item.key = ''
          this.item.value = ''
          this.$emit('showAdd', false)
          this.$emit('showMore', this.page)
          this.showToast(
            this.$t(
              this.updateData != null ? 'toasts.successUpdate' : 'toasts.successCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.buttonSubmitDisabled = false
          this.textSubmit = this.$t('forms.submit')
          this.item.key = ''
          this.item.value = ''
          this.$emit('showAdd', false)
          this.showToast(
            this.$t(
              this.updateData != null ? 'toasts.errorUpdate' : 'toasts.errorCreate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>

<style>

</style>
